import React, {useContext} from "react"
import DataContextProvider from "../../src/context/DataContextProvider.jsx"
import ActionContextProvider from "../../src/context/ActionContextProvider.jsx"
import WorkflowContextProvider from "../../src/context/WorkflowContextProvider.jsx"
import BaseDialog from "../components/dialoge/BaseDialog.jsx"
import BackofficeButton from "../components/BackofficeButton.jsx"
import NotificationListener from "../../src/context/NotificationListener.jsx"
import {GlobalContext} from "./GlobalContextProvider.jsx"

const MasterProvider = ({children}) => {
    const {isAkJsonReady} = useContext(GlobalContext)
    if (!isAkJsonReady) return null

    return (
        <DataContextProvider>
            <ActionContextProvider>
                <WorkflowContextProvider>
                    {children}
                    <BaseDialog />
                    <BackofficeButton/>
                    <NotificationListener/>
                </WorkflowContextProvider>
            </ActionContextProvider>
        </DataContextProvider>
    )
}

export default MasterProvider
